import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Helmet } from 'react-helmet-async';
import PageTitle from 'src/components/PageTitle';
import PageTitleWrapper from 'src/components/PageTitleWrapper';
import CircularProgress from '@mui/material/CircularProgress';
import { hasPermission } from 'src/components/Permissions/hasPermission';
import { 
  Box, 
  Button, 
  TextField, 
  FormControl, 
  InputLabel, 
  Select, 
  MenuItem, 
  Stack 
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import DownloadIcon from '@mui/icons-material/Download';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router';
import { get } from 'src/services/httpClient.service';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const Stb_Reconciliation = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pageSize, setPageSize] = useState(100);
  const [searchTerm, setSearchTerm] = useState('');
  const [uniqueCodeSearch, setUniqueCodeSearch] = useState('');
  const [requestTypeFilter, setRequestTypeFilter] = useState('all');

  const navigate = useNavigate();
  const getReconcileRecordData = (reconcileCode) => {
      navigate(`/OTT-Reconciliation/Stb_Reconciliation_Data/${reconcileCode}`);
  };
  

  const columns = [
    { field: 'id', headerName: 'ID', width: 90 },
    {
      field: 'reconcileCode',
      headerName: 'Unique code',
      flex: 2,
      renderCell: (params) => (
        <span
          style={{ color: '#1976d2', cursor: 'pointer' }}
          onClick={() => navigate(`/OTT-Reconciliation/Stb_Reconciliation_Data/${params.row.reconcileCode}`)}
        >
          {params.row.reconcileCode}
        </span>
      ),
    },
    { field: 'reconcileType', headerName: 'Reconcile Type', flex: 1 },
    { field: 'noOfProcess', headerName: 'No Of Process', flex: 1 },
    { field: 'remainingProcess', headerName: 'Remain Process', flex: 1 },
    //{ field: 'requestType', headerName: 'Request Type', flex: 1 },
    { field: 'crmMatchPercentage', headerName: 'CRM (%)', flex: 1 },
    { field: 'drmMatchPercentage', headerName: 'DRM (%)', flex: 1 },
    { field: 'createdDateStr', headerName: 'Added Date', flex: 1 },
    { field: 'createdBy', headerName: 'Generated At', flex: 1 },
  ];

 const handleDownloadExcel = () => {
  try {
    const headers = columns.map((col) => col.headerName);

    const dataRows = filteredRows.map((row) =>
      columns.map((col) => {
        const value = row[col.field];
        return value !== undefined && value !== null ? value : '';
      })
    );

    const excelData = [headers, ...dataRows];

    const worksheet = XLSX.utils.aoa_to_sheet(excelData);

    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      'STB Reconciliation'
    );

    const excelBuffer = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });

    const blob = new Blob([excelBuffer], {
      type:
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    saveAs(blob, 'STB_Reconciliation_Report.xlsx');
  } catch (error) {
    console.error('Excel generation failed:', error);
  }
};

  const handleDownloadPDF = () => {
    const doc = new jsPDF();
    
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(14);
    doc.text('STB Reconciliation Report', 14, 15);
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 14, 22);

    const tableColumn = columns.map((col) => col.headerName);
    const tableRows = filteredRows.map((row) =>
      columns.map((col) => {
        const value = row[col.field];
        return value !== undefined && value !== null ? String(value) : '';
      })
    );

    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: 30,
      styles: { fontSize: 8 },
      headStyles: { fillColor: [22, 160, 133] },
    });

    doc.save('STB_Reconciliation_Report.pdf');
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await get(`${process.env.REACT_APP_BASE_API_URL}/api/reconcile/type/STB_PACKAGE`);
        const reportData = response['data']? response['data'] : [];
        const dataWithId = reportData.map((item, index) => ({ 
          id: index + 1, 
          createdDateStr: dayjs(item.createdDate).format('DD-MM-YYYY HH:mm:ss'),
          ...item 
        }));
        console.log(dataWithId)
        setRows(dataWithId);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching STB reconciliation data:', error);
        setLoading(false);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const requestTypes = ['all', 'active', 'deactive'];

  const filteredRows = rows.filter((row: any) => {
  const matchesSearch = Object.values(row).some(
    (value) =>
      value &&
      value.toString().toLowerCase().includes(searchTerm.toLowerCase())
  );

  const matchesUniqueCode =
    !uniqueCodeSearch ||
    row.reconcileCode
      ?.toLowerCase()
      .includes(uniqueCodeSearch.toLowerCase());

  return matchesSearch && matchesUniqueCode;
});
  return (
    <>
      <Helmet>
        <title>STB Reconciliation</title>
      </Helmet>

      <PageTitleWrapper>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
          <Box sx={{ '& .MuiPageTitle-wrapper': { height: '80px' },paddingX:"15px" }}>
            <PageTitle
              heading="STB Reconciliation"
              handleClick={undefined}
            />
          </Box>
         
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
         { hasPermission(["OWNER"]) && (
            <>
            <Button
  variant="contained"
  color="primary"
  startIcon={<DownloadIcon />}
  onClick={handleDownloadExcel}
>
  Download Excel
</Button>
            <Button
              variant="outlined"
              color="secondary"
              startIcon={<DownloadIcon />}
              onClick={handleDownloadPDF}
              sx={{ ml: 2 }}
            >
              Download PDF
            </Button>
            </>
          )}
          </Box>
        </Box>
      </PageTitleWrapper>

      <Box sx={{ px: 2, mb: 2 }}>
        <Stack direction="row" spacing={2} alignItems="center">
          {/* Main Search */}
          <TextField
            label="Search All Fields"
            variant="outlined"
            size="small"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            sx={{ width: 300 }}
          />
          
          {/* Unique Code Search */}
          <TextField
            label="Search Unique Code"
            variant="outlined"
            size="small"
            value={uniqueCodeSearch}
            onChange={(e) => setUniqueCodeSearch(e.target.value)}
            sx={{ width: 300 }}
          />
          
          {/* Request Type Dropdown */}
          <FormControl size="small" sx={{ minWidth: 200 }}>
            <InputLabel>Request Type</InputLabel>
            <Select
              value={requestTypeFilter}
              onChange={(e) => setRequestTypeFilter(e.target.value)}
              label="Request Type"
            >
              {requestTypes.map((type) => (
                <MenuItem key={type} value={type}>
                  {type.charAt(0).toUpperCase() + type.slice(1)}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Stack>
      </Box>

      {
        loading?<Box sx={{ display: 'flex',justifyContent:"center",alignItems:"center",marginTop:'10%', }}>
              <CircularProgress />
              
            </Box>:<Box sx={{ height: 'calc(100vh - 220px)', px: 2, py: 1 }}>
        <DataGrid
          rows={filteredRows}
          columns={columns}
          pageSize={pageSize}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          rowsPerPageOptions={[5, 10, 20, 50, 100]}
          pagination
          getRowHeight={() => 'auto'}
          loading={loading}
          sx={{
            border: 2,
            borderColor: 'rgb(43 44 45)',
            '& .MuiDataGrid-cell': { alignItems: 'start', py: 1.5 },
          }}
        />
      </Box>
      }
      
    </>
  );
};

export default Stb_Reconciliation;